import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from '../bootstrap-modal';
import { InputAddOn } from '../input-group-addon';
import { DateTimeForm } from './search-date-time-form';
import searchByDateTimeHOC from './search-date-time-hoc';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

class DateTimeModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.closeModal = this.closeModal.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal () {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  }

  close () {
    this.closeModal();
  }

  closeModal () {
    this.setState({ showModal: false });
  }

  render () {
    const {
      displayDateTime,
      defaultLabel
    } = this.props;
    const isSelected = !!displayDateTime;
    const buttonClassName = classnames('btn btn-default btn-outlined-light btn-block remove-click-styling flex center', {
      'selected-filter': isSelected
    });

    return (
      <div>
        <button
          className={buttonClassName}
          onClick={this.toggleModal}
        >
          <img alt="search" src={`/web-search/assets/images/calendar-${isSelected ? 'teal' : 'gray'}.svg?v=rb`} />
          <div className="margin-md-left ellipsis">
            {displayDateTime || defaultLabel || <FormattedMessage id="search.date_time_modal.date_and_time" defaultMessage="Date & Time" />}
          </div>
        </button>
        <BootstrapModal
          showModal={this.state.showModal}
          modalSize="sm-size"
          modalClass="activity-modal"
          onClose={this.closeModal}
          body={
            <div className="container-fluid">
              <DateTimeForm
                {...this.props}
                dateColClass="text-center"
              />
            </div>
          }
        />
      </div>
    );
  }
}

DateTimeModal.propTypes = {
  displayDateTime: PropTypes.string,
  defaultLabel: PropTypes.string,
  btnClass: PropTypes.string
};

export default searchByDateTimeHOC(DateTimeModal);
